import * as React from 'react';

import {Route, Switch, useHistory} from 'react-router-dom';

import loadable from '@loadable/component';

import {loadableDelay, params} from '@common/react/loadable/loadableSettings';

import MustheadNaked from '@app/components/UI/MustHead/MustheadNaked';

const PrivacyPolicy = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "Policies" */ '@app/components/Pages/Policies/PrivacyPolicy')), params);
const TermsAndConditions = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "TermsAndConditions" */ '@app/components/Pages/Policies/TermsAndConditions')), params);
const SiteAccessibility = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "SiteAccessibility" */ '@app/components/Pages/Policies/SiteAccessibility')), params);

const Policies = () => {
	const history = useHistory();
	const title = history.location.pathname
		.split('/')[2]
		.split('-')
		.map(item => item.charAt(0).toUpperCase() + item.slice(1, item.length))
		.join(' ');
	return (
		<>
			<MustheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title={title}/>
			<Switch>
				<Route exact path="/policies/privacy-policy" component={PrivacyPolicy} />
				<Route exact path="/policies/terms-and-conditions" component={TermsAndConditions} />
				<Route exact path="/policies/accessibility-policy" component={SiteAccessibility} />
			</Switch>
		</>
	);
};

export default Policies;